import { render } from "./CurrencyInput.vue?vue&type=template&id=6bffbc7a"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__